// extracted by mini-css-extract-plugin
module.exports = {"title":"AddNewItem_title__1UHZ7","row":"AddNewItem_row__3GmG9","btns":"AddNewItem_btns__37YeB"};